import { render, staticRenderFns } from "./GoldsmithItemsList.vue?vue&type=template&id=136b37dc"
import script from "./GoldsmithItemsList.vue?vue&type=script&lang=js"
export * from "./GoldsmithItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports